var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-route-container"},[_c('h1',[_vm._v("路由测试页面")]),_c('p',[_vm._v("如果你能看到这个页面，说明路由配置工作正常。")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }